import React from "react";
import { Grid, Typography } from "@mui/material";
import * as dateFns from "date-fns";

const DayLabels = ({ startDate }) => {
  if (!startDate || isNaN(new Date(startDate).getTime())) {
    return <Typography>Error: Invalid date</Typography>; // Handle invalid date
  }

  const dateFormat = "EEE";
  const days = [];
  const startOfWeek = dateFns.startOfWeek(new Date(startDate)); // Ensure `startDate` is a valid Date object

  for (let i = 0; i < 7; i++) {
    days.push(
      <Grid item xs key={i}>
        <Typography sx={{ textAlign: "center" }}>
          {dateFns.format(dateFns.addDays(startOfWeek, i), dateFormat)}
        </Typography>
      </Grid>
    );
  }

  return <Grid container>{days}</Grid>;
};

export default DayLabels;
